<template>
<div>
  <div v-if="action == 'validation' && !isResponsed" class="cs-wechat-timer">
    <span>验证窗口将在 <span class="cs-redLabel">{{closeSeconds}}</span> 秒后关闭</span>
  </div>
  <div class="cs-wechat-top">
    <i class="fa fa-weixin" aria-hidden="true"></i>
    <span>请打开微信扫一扫，扫描二维码</span>
  </div>
  <div class="cs-wechat-middle cs-redLabel">
    *请确保已经在(https://portal.speedupedu.com)绑定了真实的微信账号*
  </div>
  <div id="login_container" class="cs-wechat-login">
    <iframe></iframe>
  </div>
</div>
</template>

<style lang="scss" scoped>
.cs-wechat-top{
  display: table;
  margin: auto;
  font-size: 18px;
  .fa{
    font-size: 40px;
    color:limegreen;
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
  }
  span{
    display: inline-block;
    vertical-align: middle;
  }
}
.cs-wechat-middle{
  font-size: 16px;
    text-align: center;
}
.cs-wechat-login{
  text-align: center;
}
.cs-wechat-timer{
  font-size: 16px;
  text-align: center;

  .cs-redLabel{
    font-size: 18px;
  }
}
</style>

<script>
import {
  compileStr,
  uncompileStr,
  getStore
} from '../../config/mUtils'
export default {
  props: {
    action:String
  },
  data() {
    return {
      closeSeconds:28,
      isResponsed: false,
      timer: null
    };
  },
  created() {
  },
  mounted() {
    let config = this.getConfig();
    if (!config){
      return;
    }
    let state = this.getState();
    let url = encodeURI("https://portal.speedupedu.com/wechatHandler");

    var obj = new WxLogin({
      self_redirect:true,
      id:"login_container", 
      appid: config.AppID, 
      scope: "snsapi_login", 
      redirect_uri: url,
      state: state,
      href:"data:text/css;base64,LmltcG93ZXJCb3glMjAudGl0bGUlMjAlN0IlMEElMjBkaXNwbGF5JTNBJTIwbm9uZSUzQiUwQSU3RCUwQS5pbXBvd2VyQm94JTIwLnN0YXR1cy5zdGF0dXNfYnJvd3NlciUyMCU3QiUwQSUyMGRpc3BsYXklM0ElMjBub25lJTNCJTBBJTdEJTBBLmltcG93ZXJCb3glMjAucXJjb2RlJTIwJTdCJTBBJTIwYm9yZGVyJTNBJTIwbm9uZSUzQiUwQSUyMHdpZHRoJTNBJTIwMjAwcHglM0IlMEElMjBoZWlnaHQlM0ElMjAyMDBweCUzQiUwQSU3RCUwQS5pbXBvd2VyQm94JTIwLnN0YXR1cyU3QiUwQSUyMGRpc3BsYXklM0ElMjBub25lJTBBJTdE"
    });
    
    window.addEventListener('message', this.receiveMsg);

    if (this.action == 'validation'){
      this.timer = setInterval(() => {
        this.closeSeconds --;
        if (this.closeSeconds <= 0){
          this.$message({
            message: '微信验证已超时，请点击登录按钮重新进行验证',
            type: 'warning',
            duration: 10000
          });
          this.$emit("fail");
          clearInterval(this.timer);
        }
      }, 1000);
    }
  },
  beforeDestroy(){
    window.removeEventListener('message', this.receiveMsg);
  },
  methods: {
    receiveMsg(event){
	    const data = event.data
  
	    switch (data.cmd) {
	      case 'validation':{
	        if (data.params.success){
            this.$emit("success");
          }else{
            this.$message.error(data.params.message);
            this.$emit("fail");
          }
	        break;
        }
        case 'wechatHandler':{
          this.isResponsed = true;
          if (this.timer){
            clearInterval(this.timer);
            this.timer = null;
          }
        }
	    }
    },
    getConfig(){
      let configStr = getStore("weChatConfig");
      if (!configStr){
        this.$message.warning("微信设置未配置，请重新登录");
        return false;
      }

      let configObj = JSON.parse(uncompileStr(configStr));
      return configObj;
    },
    getState(){
      let token = getStore("auth_token");
      let url = `${window.location.protocol}//${window.location.host}/wechatResponse`;
      let state = {action:this.action, token:token, url: url};
      let str = JSON.stringify(state).replace(/"/g, "{}");
      return str;
    }
  },
  watch: {
   
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/wechartLogin.vue